/* pod-site.js · JS do site (layout theme). Carregado pela faixa de marcas.
   1) menu do pod-header  2) chips de sabor do pod-best-sellers  3) utilidades */
(function () {
  'use strict';
  if (window.__podSite) return;
  window.__podSite = true;

  var money = function (cents) {
    var v = (cents / 100).toFixed(2).split('.');
    var i = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + i + (v[1] === '00' ? '' : ',' + v[1]);
  };
  var rootUrl = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  /* pedidos ao carrinho por um fetch "limpo" (iframe da mesma origem): os pixels da Shopify (canal Facebook, Google e apps)
     interceptam o fetch da janela e disparam 1 AddToCart por linha, com preço unitário; o tema dispara o evento certo
     (1 por clique, valor do kit) pela section pod-site-pixel, no evento pod:add. Mantém cookies e sessão do carrinho. */
  var podCartFetch = function (path, opts) {
    var url = /^https?:/.test(path) ? path : location.origin + path;
    var f = null;
    try {
      var fr = document.getElementById('pod-cart-frame');
      if (!fr && document.body) { fr = document.createElement('iframe'); fr.id = 'pod-cart-frame'; fr.setAttribute('aria-hidden', 'true'); fr.tabIndex = -1; fr.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden'; document.body.appendChild(fr); }
      if (fr && fr.contentWindow && typeof fr.contentWindow.fetch === 'function') f = fr.contentWindow.fetch.bind(fr.contentWindow);
    } catch (e) { f = null; }
    opts = opts || {}; if (!opts.credentials) opts.credentials = 'same-origin';
    return (f || window.fetch)(url, opts);
  };

  /* ---------- faixas da Yampi (ajuste do tema "Pod: faixas da Yampi") ----------
     "12:5" = 5% a partir de 12; "12=159" = preço do grupo com exatamente 12;
     "12@13,25" = R$ 13,25 a unidade a partir de 12. Separa só na vírgula seguida de outra faixa. */
  var podCents = function (x) { x = String(x).replace(/[^\d.,]/g, ''); if (x.indexOf(',') > -1) x = x.replace(/\./g, '').replace(',', '.'); return Math.round(parseFloat(x) * 100); };
  var podParseTiers = function (str) {
    return String(str || '').split(/\s*[,;]\s*(?=\d+\s*[=:@])/).map(function (x) {
      x = x.trim();
      var m = x.match(/^(\d+)\s*([=@:])\s*(.+)$/); if (!m) return { n: 0 };
      var n = parseInt(m[1], 10);
      if (m[2] === '=') return { n: n, v: podCents(m[3]) };
      /* unidade com mais de 2 casas (4@74,975 = R$ 299,90 por 4): guarda o centavo fracionado e arredonda só o total */
      if (m[2] === '@') { var uf = String(m[3]).replace(/[^\d.,]/g, ''); if (uf.indexOf(',') > -1) uf = uf.replace(/\./g, '').replace(',', '.'); return { n: n, u: Math.round(parseFloat(uf) * 10000) / 100 }; }
      return { n: n, p: parseFloat(String(m[3]).replace(',', '.')) };
    }).filter(function (t) { return t.n > 0 && (t.p > 0 || t.v > 0 || t.u > 0); }).sort(function (a, b) { return a.n - b.n; });
  };
  var faixasMap = null;
  var podFaixas = function () {
    if (faixasMap) return faixasMap;
    faixasMap = {};
    var el = document.getElementById('pod-faixas');
    if (el) String(el.getAttribute('data-faixas') || '').split(/\r?\n/).forEach(function (l) { var a = l.split('|'); if (a.length > 1 && a[0].trim()) faixasMap[a[0].trim()] = podParseTiers(a[1]); });
    return faixasMap;
  };
  /* preço da unidade no checkout para N unidades do produto (só faixas por unidade e %): null sem faixa */
  var podUnitAt = function (handle, units, price) {
    var t = podFaixas()[handle]; if (!t || !t.length) return null;
    var cur = null; t.forEach(function (x) { if (units >= x.n && (x.u || x.p)) cur = x; });
    if (!cur) return null;
    return cur.u ? cur.u : Math.round(price * (100 - cur.p) / 100);
  };
  /* regras de brinde por produto, gravadas quando a caixa de packs adiciona: a gaveta usa para pôr o brinde
     do kit maior quando a quantidade sobe ali. Brinde tirado pela lixeira fica recusado até fechar a aba. */
  var podStore = function (st, key, val) {
    try {
      var o = JSON.parse(st.getItem(key) || '{}') || {};
      if (val === undefined) return o;
      o = Object.assign(o, val); st.setItem(key, JSON.stringify(o)); return o;
    } catch (e) { return {}; }
  };
  var podGiftCfg = function (val) { try { return podStore(window.localStorage, 'podBrindes', val); } catch (e) { return {}; } };
  var podGiftNo = function (val) { try { return podStore(window.sessionStorage, 'podBrindesNao', val); } catch (e) { return {}; } };
  /* regras de brinde do ajuste do tema "Pod: brindes" (valem em qualquer página, ex.: Monte seu kit) */
  var giftGlobal = null;
  var podGiftGlobal = function () {
    if (giftGlobal) return giftGlobal;
    giftGlobal = {};
    try { var el = document.getElementById('pod-brindes'); if (el && el.getAttribute('data-brindes')) giftGlobal = JSON.parse(el.getAttribute('data-brindes')) || {}; } catch (e) { giftGlobal = {}; }
    /* regra com data de fim ("e", ISO) vencida deixa de valer: o tema para de pôr o brinde quando o desconto da Yampi expira (Black: 30/11 23:59) */
    try { Object.keys(giftGlobal).forEach(function (k) { var c = giftGlobal[k]; if (c && c.e && Date.parse(c.e) < Date.now()) delete giftGlobal[k]; }); } catch (e2) {}
    return giftGlobal;
  };

  /* ---------- brindes por valor (escada da Black) sincronizados pelo carrinho real ----------
     Lê o /cart.js, soma os produtos da regra (prefixo h, sem brinde) e põe o degrau que falta ou tira o que
     deixou de valer, um pedido por degrau. Usado pelas boxes (A e B) antes de abrir a gaveta ou ir à Yampi,
     para o brinde não depender do total da box sozinha (carrinho com duas boxes pagava latinha a R$ 14). */
  var podGiftSyncByValue = function () {
    var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' }, all = Object.assign({}, podGiftGlobal(), podGiftCfg()), no = podGiftNo();
    return podCartFetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart && cart.items) || [], adds = [], drop = {};
      Object.keys(all).forEach(function (hk) {
        var c = all[hk]; if (!c || !c.v || !c.t) return;
        var pre = c.h || '', val = 0, have = {};
        items.forEach(function (it) {
          var p = it.properties || {};
          if (p._brinde) { if (p._brinde_de === hk) (have[p._brinde] = have[p._brinde] || []).push(it.key); return; }
          if (String(it.handle || '').indexOf(pre) === 0) val += it.final_line_price || 0;
        });
        c.t.forEach(function (t) {
          if (!t.items || !t.items.length) return;
          var k = String(t.min);
          if (val >= t.min && !have[k] && !no[hk + ':' + k]) adds.push(t.items.map(function (x) { return { id: x[0], quantity: x[1], properties: { _brinde: k, _brinde_de: hk, _origem: c.o || 'site-gaveta' } }; }));
          if (val < t.min && have[k]) have[k].forEach(function (key) { drop[key] = 0; });
        });
      });
      var chain = Promise.resolve(null);
      adds.forEach(function (lines) { chain = chain.then(function () { return podCartFetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: lines }) }).then(function (r) { return r.json(); }); }); });
      if (Object.keys(drop).length) chain = chain.then(function () { return podCartFetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: drop }) }).then(function (r) { return r.json(); }); });
      return chain;
    });
  };
  /* a box já está no carrinho? (linhas com _box = id) */
  var podCartHasBox = function (boxId) {
    return podCartFetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { return ((cart && cart.items) || []).some(function (it) { return it.properties && it.properties._box === boxId; }); })
      .catch(function () { return false; });
  };
  /* HTML da gaveta e da bolinha sem mexer no carrinho */
  var podCartSections = function () {
    return podCartFetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) }).then(function (r) { return r.json(); });
  };
  var podDrawerShow = function (res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && res && res.sections) {
      drawer.classList.toggle('is-empty', !res.item_count);
      var inn = drawer.querySelector('.drawer__inner'); if (inn) inn.classList.toggle('is-empty', !res.item_count);
      drawer.renderContents(res); return true;
    }
    return false;
  };

  /* ---------- header: painel mobile, mega menu, dropdown, esconder ao rolar ---------- */
  function initHeader(h) {
    if (h.__podInit) return;
    h.__podInit = true;
    var root = document.documentElement;
    var wrap = h.closest('.pod-header-section') || h.parentElement;
    var burger = h.querySelector('[data-pod-menu-toggle]');
    var menu = h.querySelector('[data-pod-menu]');
    var mega = h.querySelector('[data-pod-mega]');
    var megaBtn = h.querySelector('[data-pod-mega-toggle]');
    var scrim = h.querySelector('[data-pod-scrim]');
    var lastFocus = null;
    var hoverable = function () { return window.matchMedia('(hover:hover) and (min-width:990px)').matches; };
    var focusables = function (el) { return Array.prototype.slice.call(el.querySelectorAll('a[href],button:not([disabled]),summary,input')).filter(function (x) { return x.offsetParent !== null; }); };
    var setScrim = function () { if (scrim) scrim.hidden = !((menu && !menu.hidden) || (mega && !mega.hidden)); };

    var closeMenu = function (back) {
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', burger.dataset.labelOpen || 'Abrir menu');
      root.classList.remove('pod-menu-open');
      setScrim();
      if (back !== false && lastFocus) lastFocus.focus();
    };
    var openMenu = function () {
      closeMega(false);
      lastFocus = document.activeElement;
      wrap.classList.remove('is-hidden');
      menu.style.setProperty('--pod-menu-top', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
      menu.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', burger.dataset.labelClose || 'Fechar menu');
      root.classList.add('pod-menu-open');
      setScrim();
      var f = focusables(menu)[0]; if (f) f.focus({ preventScroll: true });
    };
    var closeMega = function (back) {
      if (!mega || mega.hidden) return;
      mega.hidden = true;
      if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false');
      setScrim();
      if (back && megaBtn) megaBtn.focus();
    };
    var openMega = function () {
      if (!mega) return;
      mega.hidden = false;
      if (megaBtn) megaBtn.setAttribute('aria-expanded', 'true');
      setScrim();
    };

    if (burger && menu) {
      burger.addEventListener('click', function () { if (menu.hidden) openMenu(); else closeMenu(); });
      menu.addEventListener('click', function (e) { if (e.target.closest('a[href]')) closeMenu(false); });
      // adicionar pelo atalho do mais pedido: fecha o painel, a gaveta do Dawn abre
      menu.addEventListener('submit', function () { setTimeout(function () { closeMenu(false); }, 50); });
    }
    if (mega && megaBtn) {
      megaBtn.addEventListener('click', function () { if (mega.hidden) openMega(); else if (!hoverable()) closeMega(); });
      var t = null;
      var enter = function () { if (!hoverable()) return; clearTimeout(t); openMega(); };
      var leave = function () { if (!hoverable()) return; clearTimeout(t); t = setTimeout(function () { closeMega(); }, 180); };
      megaBtn.addEventListener('mouseenter', enter);
      mega.addEventListener('mouseenter', enter);
      megaBtn.addEventListener('mouseleave', leave);
      mega.addEventListener('mouseleave', leave);
      mega.addEventListener('submit', function () { setTimeout(function () { closeMega(); }, 50); });
    }
    if (scrim) scrim.addEventListener('click', function () { closeMenu(false); closeMega(); });

    // dropdowns simples (A Pod)
    h.querySelectorAll('[data-pod-dd]').forEach(function (dd) {
      var b = dd.querySelector('button');
      var p = dd.querySelector('[data-pod-dd-panel]');
      if (!b || !p) return;
      var set = function (open) { p.hidden = !open; b.setAttribute('aria-expanded', String(open)); };
      b.addEventListener('click', function () { set(p.hidden); });
      dd.addEventListener('mouseenter', function () { if (hoverable()) set(true); });
      dd.addEventListener('mouseleave', function () { if (hoverable()) set(false); });
      dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) set(false); });
    });

    // Esc fecha; Tab fica preso no painel aberto
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (menu && !menu.hidden) closeMenu();
        if (mega && !mega.hidden) closeMega(true);
        h.querySelectorAll('[data-pod-dd-panel]').forEach(function (p) { if (!p.hidden) { p.hidden = true; var b = p.parentElement.querySelector('button'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); } } });
      } else if (e.key === 'Tab' && menu && !menu.hidden) {
        var list = [burger].concat(focusables(menu));
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.matchMedia('(min-width:990px)').matches) closeMenu(false); else closeMega(); });

    // esconde ao rolar para baixo no mobile; volta ao rolar para cima
    if (h.hasAttribute('data-hide-on-scroll')) {
      var lastY = window.scrollY, ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var mobile = !window.matchMedia('(min-width:990px)').matches;
          var locked = (menu && !menu.hidden) || document.querySelector('cart-drawer.active');
          if (!mobile || y < 120 || locked) wrap.classList.remove('is-hidden');
          else if (y > lastY + 6) wrap.classList.add('is-hidden');
          else if (y < lastY - 6) wrap.classList.remove('is-hidden');
          lastY = y; ticking = false;
        });
      }, { passive: true });
    }
  }

  /* ---------- best sellers: chips de sabor → variante ---------- */
  function podNorm(x) { return String(x || '').replace(/[\u200B-\u200D\u2060\uFEFF]/g, '').trim().toLowerCase(); }
  function initCard(card) {
    var dataEl = card.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = card.querySelector('input[name="id"]');
    var priceEl = card.querySelector('[data-pod-price]');
    var cmpEl = card.querySelector('[data-pod-compare]');
    var img = card.querySelector('[data-pod-img]');
    var btn = card.querySelector('button[type="submit"]');
    var fixed = (card.dataset.fix || '').split('=');
    var fixName = fixed[0] || '';
    var fixVal = fixed[1] || '';
    var optName = card.dataset.opt || '';

    var match = function (flavor) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        if (fixName && podNorm(v.o[fixName]) !== podNorm(fixVal)) ok = false;
        if (optName && flavor && v.o[optName] !== flavor) ok = false;
        if (ok) return v;
      }
      return null;
    };
    var qty = parseInt(card.dataset.qty, 10) || 1;
    /* unidades por clique (produto unitário): preço pela faixa da Yampi, riscado = preço da unidade */
    var addN = parseInt(card.dataset.add, 10) || 1;
    var cHandle = card.dataset.handle || '';
    var unitEl = card.querySelector('[data-pod-unit]');
    var btnPrice = card.querySelector('[data-pod-btn-price]');
    var btnLabel = card.querySelector('[data-pod-add-label]');
    var nameEl = card.querySelector('[data-pod-chip-name]');
    var swap = card.dataset.swap === 'true';
    var apply = function (v, name) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var tot = v.p * addN, was = v.c && v.c > v.p ? v.c * addN : 0, uAt = v.p;
      if (addN > 1) { var fu = podUnitAt(cHandle, addN, v.p); if (fu && fu < v.p) { was = tot; uAt = fu; tot = Math.round(fu * addN); } }
      if (priceEl) priceEl.textContent = money(tot);
      if (cmpEl) { cmpEl.textContent = was ? money(was) : ''; cmpEl.hidden = !was; }
      if (unitEl) unitEl.textContent = money(addN > 1 ? uAt : Math.round(v.p / qty));
      if (btnPrice) btnPrice.textContent = money(tot);
      if (nameEl && name) nameEl.textContent = name;
      if (swap && img && v.img && img.src !== v.img) { img.removeAttribute('srcset'); img.src = v.img; }
      if (btn) { btn.disabled = !v.a; if (btnLabel) btnLabel.textContent = v.a ? btn.dataset.label : btn.dataset.soldout; }
    };
    var chips = card.querySelectorAll('[data-pod-chip]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        apply(match(c.dataset.podChip), c.dataset.podChip);
      });
    });
    var first = card.querySelector('[data-pod-chip][aria-pressed="true"]') || chips[0];
    apply(match(first ? first.dataset.podChip : ''));
  }

  /* ---------- PDP: caixa de compra (pod-buybox) ---------- */
  /* ---------- caixa de compra: partes comuns aos modos link Yampi e packs ---------- */
  function boxShared(root) {
    var galMain = root.querySelector('[data-pod-gal-main]');
    var baseImg = galMain ? galMain.getAttribute('src') : '';
    var baseSrcset = galMain ? galMain.getAttribute('srcset') : '';
    var api = {
      setGallery: function (src) {
        if (!galMain) return;
        if (src) { galMain.removeAttribute('srcset'); galMain.src = src; }
        else { galMain.src = baseImg; if (baseSrcset) galMain.setAttribute('srcset', baseSrcset); }
        root.querySelectorAll('[data-pod-thumb]').forEach(function (t) { t.setAttribute('aria-current', t.dataset.podThumb === galMain.src ? 'true' : 'false'); });
      },
      setTotals: function (cents, units, unit) {
        root.querySelectorAll('[data-pod-total]').forEach(function (e) { e.textContent = money(cents); });
        var po = root.querySelector('[data-pod-plan-once]'); if (po) po.textContent = money(cents);
        var u = units > 0 ? Math.round(cents / units) : 0;
        var pu = root.querySelector('[data-pod-plan-unit]'); if (pu) pu.textContent = u ? money(u) + '/' + unit : '';
        var ul = root.querySelector('[data-pod-unit-line]'); if (ul) ul.textContent = u ? money(u) + ' por ' + unit : '';
        var sep = root.querySelector('[data-pk-note-sep]'); if (sep) sep.textContent = u ? ' · ' : '';
      },
      setSticky: function (txt) { var s = root.querySelector('[data-pod-sticky-sub]'); if (s && txt) s.textContent = txt; }
    };
    root.querySelectorAll('[data-pod-thumb]').forEach(function (t) { t.addEventListener('click', function () { api.setGallery(t.dataset.podThumb); }); });
    root.querySelectorAll('[data-pod-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        root.querySelectorAll('[data-pod-plan]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
      });
    });
    var stickyBtn = root.querySelector('[data-pod-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var top = root.getBoundingClientRect().top + window.pageYOffset - 8;
      window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    var sticky = root.querySelector('[data-pod-pdp-sticky]');
    var anchor = root.querySelector('[data-pod-buy-anchor]');
    if (sticky && anchor) {
      var tick = false;
      var upd = function () { tick = false; sticky.classList.toggle('show', anchor.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    }
    return api;
  }

  /* ---------- caixa de compra · modo link Yampi (oferta fechada) ---------- */
  function initBoxYampi(root) {
    var ui = boxShared(root);
    var unit = root.dataset.unit || 'un.';
    var offers = root.querySelectorAll('[data-pod-offer]');
    var sabores = root.querySelectorAll('[data-pod-sabor]');
    var go = root.querySelector('[data-pod-yampi-go]');
    var label = root.querySelector('[data-pod-add-label]');
    var saborName = root.querySelector('[data-pod-sabor-name]');
    var sDesc = root.querySelector('[data-pod-sabor-desc]');
    var picked = false;
    var checked = function (list) { for (var i = 0; i < list.length; i++) if (list[i].getAttribute('aria-checked') === 'true' && !list[i].hidden) return list[i]; return null; };
    var codes = function (o) { try { return JSON.parse(o.dataset.codes || '{}'); } catch (e) { return {}; } };
    var link = function (code) {
      var base = go.dataset.base || '';
      var u = base + code;
      try {
        var x = new URL(u, location.origin);
        new URLSearchParams(location.search).forEach(function (v, k) { if (k !== 'preview_theme_id' && k !== 'view' && !x.searchParams.has(k)) x.searchParams.set(k, v); });
        var slug = go.dataset.slug;
        if (slug) {
          if (!x.searchParams.has('metadata[origem]')) x.searchParams.set('metadata[origem]', slug);
          if (go.dataset.stamp === '1' && !x.searchParams.has('utm_content')) x.searchParams.set('utm_content', slug);
        }
        u = x.toString();
      } catch (e) {}
      return u;
    };
    var render = function () {
      var o = checked(offers) || offers[0]; if (!o) return;
      var map = codes(o), star = map['*'];
      // sabor sem código nesta oferta some (ex.: Misto só nos kits)
      sabores.forEach(function (b) { var off = !star && !map[b.dataset.podSabor]; b.hidden = off; b.disabled = off; });
      var sb = checked(sabores);
      if (sabores.length && !sb) {
        for (var i = 0; i < sabores.length; i++) if (!sabores[i].hidden) { sabores.forEach(function (x) { x.setAttribute('aria-checked', 'false'); }); sabores[i].setAttribute('aria-checked', 'true'); sb = sabores[i]; break; }
      }
      var code = sb ? (map[sb.dataset.podSabor] || star) : star;
      var price = +o.dataset.price || 0, qty = +o.dataset.podOffer || 1;
      ui.setTotals(price, qty, unit);
      var nm = sb && sb.querySelector('b') ? sb.querySelector('b').textContent : '';
      if (saborName) saborName.textContent = nm;
      if (sDesc) { var d = sb ? sb.dataset.desc || '' : ''; sDesc.textContent = d; sDesc.hidden = !d; }
      ui.setSticky((o.dataset.name || '') + (nm ? ' · ' + nm : ''));
      if (go) {
        if (code) { go.href = link(code); go.removeAttribute('aria-disabled'); go.removeAttribute('tabindex'); if (label) label.textContent = go.dataset.label; }
        else { go.href = go.dataset.fallback || '#'; go.setAttribute('aria-disabled', 'true'); go.setAttribute('tabindex', '-1'); if (label) label.textContent = go.dataset.soldout; }
      }
      if (picked && sb && sb.dataset.img) ui.setGallery(sb.dataset.img);
      gifts(o, qty);
    };
    /* brindes: os da oferta escolhida (grátis) e os da próxima oferta com brinde (bloqueados) */
    var gPanel = root.querySelector('[data-pod-gifts]');
    var gUp = gPanel && gPanel.querySelector('[data-gf-up]');
    var gNext = null;
    var gifts = function (o, q) {
      if (!gPanel) return;
      var items = gPanel.querySelectorAll('[data-gf-offers]');
      var has = function (it, n) { return (it.dataset.gfOffers || '').indexOf(',' + n + ',') > -1; };
      var nm = function (x) { return x ? (x.dataset.name || x.dataset.podOffer) : ''; };
      gNext = null;
      Array.prototype.slice.call(offers).filter(function (x) { return +x.dataset.podOffer > q && +x.dataset.giftValue > 0; })
        .sort(function (a, b) { return +a.dataset.podOffer - +b.dataset.podOffer; })
        .forEach(function (x) { if (!gNext) gNext = x; });
      var on = 0, shown = 0, nq = gNext ? +gNext.dataset.podOffer : 0;
      var gv = +o.dataset.giftValue || 0;
      /* oferta especial (sem valor de brinde, com brinde próprio, ex.: Leve 5): não mostra os bloqueados */
      var own = Array.prototype.some.call(items, function (it) { return has(it, q); });
      var lockOk = gv > 0 || !own;
      items.forEach(function (it) {
        var isOn = has(it, q), isNext = !isOn && lockOk && nq && has(it, nq);
        it.hidden = !isOn && !isNext;
        it.classList.toggle('is-locked', !!isNext);
        var st = it.querySelector('[data-gf-state]');
        if (st) st.textContent = isOn ? 'Incluso' : (isNext ? 'com ' + nm(gNext) : '');
        if (isOn) on++;
        if (!it.hidden) shown++;
      });
      var title = gPanel.querySelector('[data-gf-title]');
      if (title) {
        if (on && gv) title.innerHTML = 'Você ganha <b>' + money(gv) + ' em brindes</b>';
        else if (on) title.textContent = on > 1 ? 'Brindes desta oferta' : 'Brinde desta oferta';
        else title.textContent = 'Brindes nas ofertas maiores';
      }
      if (gUp) {
        var ngv = gNext ? +gNext.dataset.giftValue || 0 : 0;
        gUp.hidden = !gNext;
        if (gNext) gUp.innerHTML = 'Leve ' + nm(gNext) + ' e ganhe ' + (ngv ? '<b>' + money(ngv) + ' em brindes</b>' : 'mais brindes') + ' <span aria-hidden="true">&rsaquo;</span>';
      }
      gPanel.hidden = !shown;
    };
    if (gUp) gUp.addEventListener('click', function () { if (gNext) gNext.click(); });
    offers.forEach(function (b) {
      b.addEventListener('click', function () {
        offers.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        render();
      });
    });
    sabores.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.hidden) return;
        sabores.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        picked = true;
        render();
      });
    });
    /* a oferta abre um checkout só com ela: com itens no carrinho do site, avisa antes de sair */
    var warn = root.querySelector('[data-pod-cartwarn]');
    var leave = function () {
      var o = checked(offers);
      try { document.dispatchEvent(new CustomEvent('pod:checkout', { detail: { value: o ? +o.dataset.price : 0, name: o ? o.dataset.name : '', url: go.href } })); } catch (err) {}
      location.href = go.href;
    };
    if (go) go.addEventListener('click', function (e) {
      e.preventDefault();
      if (go.getAttribute('aria-disabled') === 'true') return;
      if (!warn || go.dataset.cartOk === '1') return leave();
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var n = c && c.item_count ? c.item_count : 0;
        if (!n) return leave();
        var t = warn.querySelector('[data-pod-cartwarn-t]');
        if (t) t.textContent = 'Você tem ' + n + (n === 1 ? ' item' : ' itens') + ' no carrinho. Esta oferta abre um checkout só com ela; o carrinho fica salvo para depois.';
        warn.hidden = false;
      }).catch(leave);
    });
    if (warn) {
      var wGo = warn.querySelector('[data-pod-cartwarn-go]'), wCart = warn.querySelector('[data-pod-cartwarn-cart]');
      if (wGo) wGo.addEventListener('click', function () { go.dataset.cartOk = '1'; warn.hidden = true; leave(); });
      if (wCart) wCart.addEventListener('click', function () {
        warn.hidden = true;
        var icon = document.getElementById('cart-icon-bubble');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(icon); else if (icon) icon.click();
      });
    }
    render();
  }

  /* ---------- caixa de compra · modo packs (mix livre → carrinho) ---------- */
  function initBoxPacks(root) {
    var ui = boxShared(root);
    var cfg = root.querySelector('[data-pod-step="packs"]'); if (!cfg) return;
    var d = cfg.dataset;
    /* textos padrão aqui: a Shopify recusa chaves dentro de {{ }} no Liquid */
    if (!d.msgMin) d.msgMin = 'Escolha pelo menos {n} {u}';
    if (!d.msgNext) d.msgNext = 'Faltam {n} {u} para {p}% off';
    if (!d.msgOn) d.msgOn = '{p}% off aplicado';
    if (!d.msgNextV) d.msgNextV = 'Faltam {n} {u} para o kit de {k} por {v}';
    if (!d.msgOnV) d.msgOnV = 'Kit de {k} por {v}';
    if (!d.msgKit) d.msgKit = 'Faltam {n} {u} para o kit de {k}';
    if (!d.msgNextU) d.msgNextU = 'Faltam {n} {u} para {x} a unidade';
    if (!d.msgOnU) d.msgOnU = '{x} a unidade';
    var step = +d.step || 1, per = +d.per || 1, minU = +d.min || 1, maxU = +d.max || 240;
    var many = d.unitMany || 'un.', one = d.unitOne || many;
    var unit = root.dataset.unit || one;
    var clickU = step * per;
    /* faixas: "12:5" = 5% a partir de 12; "12=159" = preço do grupo com exatamente 12 (R$);
       "12@13,25" = R$ 13,25 a unidade a partir de 12 (desconto progressivo da Yampi por unidade).
       Separa só na vírgula seguida de outra faixa, para aceitar centavos com vírgula. */
    var tiers = podParseTiers(d.tiers);
    var handle = d.pkHandle || '';
    var kits = String(d.kits || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    if (kits.length && kits[0] > minU) minU = kits[0];
    var maxTotal = kits.length ? kits[kits.length - 1] : Infinity;
    /* kit escolhido antes dos sabores: o total precisa fechar o kit do card */
    var kitBtns = root.querySelectorAll('[data-pk-kit]');
    var kitPick = kitBtns.length > 1, curKit = 0;
    var pickKit = function (b) {
      kitBtns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      curKit = +b.dataset.pkKit; minU = curKit; maxTotal = curKit;
    };
    if (kitPick) pickKit(Array.prototype.filter.call(kitBtns, function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || kitBtns[0]);
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pk-id]'));
    var addBtn = root.querySelector('[data-pod-packs-add]');
    var label = root.querySelector('[data-pod-add-label]');
    var unitsEl = root.querySelector('[data-pk-units]');
    var minNote = root.querySelector('[data-pk-min-note]');
    var tierEl = root.querySelector('[data-pk-tier]');
    var bar = root.querySelector('[data-pk-bar]');
    var err = root.querySelector('[data-pk-err]');
    var cartNote = root.querySelector('[data-pk-cart-note]');
    var q = {};
    rows.forEach(function (r) { var n = +r.dataset.q || 0; if (n) q[r.dataset.pkId] = n; });
    var fill = function (t, o) { return String(t || '').replace('{n}', o.n == null ? '' : o.n).replace('{u}', o.u || '').replace('{p}', o.p == null ? '' : String(o.p).replace('.', ',')).replace('{k}', o.k == null ? '' : o.k).replace('{v}', o.v == null ? '' : money(o.v)).replace('{x}', o.x == null ? '' : money(o.x)); };
    var uw = function (n) { return n === 1 ? one : many; };
    var totals = function () {
      var units = 0, cents = 0;
      rows.forEach(function (r) { var n = q[r.dataset.pkId] || 0; units += n * per; cents += n * (+r.dataset.price || 0); });
      /* preço estimado no checkout: faixa atingida (preço do grupo ou %) */
      var cur = null;
      tiers.forEach(function (x) { if (units >= x.n) cur = x; });
      var est = cents;
      if (cur && cur.v && units === cur.n) est = cur.v;
      else if (cur && cur.u) est = Math.round(units * cur.u);
      else if (cur && cur.p) est = Math.round(cents * (100 - cur.p) / 100);
      return { units: units, cents: cents, est: est, tier: cur };
    };
    var render = function () {
      var t = totals();
      rows.forEach(function (r) {
        var n = q[r.dataset.pkId] || 0;
        r.querySelector('[data-pk-q]').textContent = n * per;
        r.classList.toggle('is-on', n > 0);
        r.querySelector('[data-pk-dec]').disabled = n < 1;
        r.querySelector('[data-pk-inc]').disabled = r.hasAttribute('data-off') || (n + step) * per > maxU || t.units + clickU > maxTotal;
      });
      if (unitsEl) unitsEl.textContent = kitPick ? t.units + ' de ' + curKit + ' ' + many : t.units + ' ' + uw(t.units);
      var okKit = kitPick ? t.units === curKit : (!kits.length || kits.indexOf(t.units) > -1);
      var ok = t.units >= minU && okKit;
      var why = '';
      if (kitPick) { if (t.units < curKit) why = fill(d.msgKit, { n: curKit - t.units, u: uw(curKit - t.units), k: curKit }); }
      else if (t.units < minU) why = fill(d.msgMin, { n: minU, u: many });
      else if (!okKit) { var nk = kitPick ? curKit : kits.filter(function (k) { return k > t.units; })[0]; if (nk) why = fill(d.msgKit, { n: nk - t.units, u: uw(nk - t.units), k: nk }); }
      if (minNote) minNote.textContent = ok ? '' : ' · ' + why;
      ui.setTotals(t.est, t.units, unit);
      if (addBtn) { addBtn.disabled = !ok; if (label) label.textContent = ok ? addBtn.dataset.label : why; }
      if (cartNote) cartNote.hidden = true;
      if (kitPick) {
        /* o card do kit já mostra o preço: a barra só mostra quanto do kit está cheio */
        if (tierEl) { tierEl.textContent = ''; tierEl.classList.remove('is-on'); }
        if (bar) bar.style.width = Math.min(100, Math.round(t.units * 100 / (curKit || 1))) + '%';
      } else if (tiers.length && tierEl) {
        var next = tiers.filter(function (x) { return x.n > t.units; })[0];
        var cur = t.tier, msg = '', on = '';
        if (cur) on = cur.v ? (t.units === cur.n ? fill(d.msgOnV, { k: cur.n, v: cur.v }) : '') : (cur.u ? fill(d.msgOnU, { x: cur.u }) : fill(d.msgOn, { p: cur.p }));
        if (next) msg = next.v ? fill(d.msgNextV, { n: next.n - t.units, u: uw(next.n - t.units), k: next.n, v: next.v }) : (next.u ? fill(d.msgNextU, { n: next.n - t.units, u: uw(next.n - t.units), x: next.u }) : fill(d.msgNext, { n: next.n - t.units, u: uw(next.n - t.units), p: next.p }));
        else if (cur && d.msgMax) msg = fill(d.msgMax, { k: cur.n, p: cur.p, v: cur.v, x: cur.u });
        tierEl.textContent = [on, msg].filter(Boolean).join(' · ');
        tierEl.classList.toggle('is-on', !!on);
        if (bar) { var top = tiers[tiers.length - 1].n; bar.style.width = Math.min(100, Math.round(t.units * 100 / top)) + '%'; }
      }
      ui.setSticky(t.units ? t.units + ' ' + uw(t.units) : '');
      gifts(kitPick ? curKit : t.units);
    };
    /* brindes do kit escolhido (grátis no checkout) e os do próximo kit com brinde (bloqueados) */
    var gPanel = root.querySelector('[data-pod-gifts]');
    var gUp = gPanel && gPanel.querySelector('[data-gf-up]');
    var gNext = null;
    var gifts = function (k) {
      if (!gPanel) return;
      var items = gPanel.querySelectorAll('[data-gf-offers]');
      var has = function (it, n) { return (it.dataset.gfOffers || '').indexOf(',' + n + ',') > -1; };
      var cur = Array.prototype.filter.call(kitBtns, function (b) { return +b.dataset.pkKit === k; })[0];
      gNext = Array.prototype.slice.call(kitBtns).filter(function (b) { return +b.dataset.pkKit > k && +b.dataset.giftValue > 0; })
        .sort(function (a, b) { return +a.dataset.pkKit - +b.dataset.pkKit; })[0] || null;
      var nq = gNext ? +gNext.dataset.pkKit : 0, gv = cur ? +cur.dataset.giftValue || 0 : 0, on = 0, shown = 0;
      items.forEach(function (it) {
        var isOn = has(it, k), isNext = !isOn && nq && has(it, nq);
        it.hidden = !isOn && !isNext;
        it.classList.toggle('is-locked', !!isNext);
        it.classList.toggle('is-on', !!isOn);
        var st = it.querySelector('[data-gf-state]');
        if (st) st.textContent = isOn ? 'Incluso' : (isNext ? 'com ' + (gNext.dataset.name || nq) : '');
        if (isOn) on++;
        if (!it.hidden) shown++;
      });
      var title = gPanel.querySelector('[data-gf-title]');
      if (title) {
        if (on && gv) title.innerHTML = 'Você ganha <b>' + money(gv) + ' em brindes</b>';
        else if (on) title.textContent = on > 1 ? 'Brindes deste kit' : 'Brinde deste kit';
        else title.textContent = 'Brindes nos kits maiores';
      }
      if (gUp) {
        var ngv = gNext ? +gNext.dataset.giftValue || 0 : 0;
        gUp.hidden = !gNext;
        if (gNext) gUp.innerHTML = 'Leve ' + (gNext.dataset.name || nq) + ' e ganhe ' + (ngv ? '<b>' + money(ngv) + ' em brindes</b>' : 'mais brindes') + ' <span aria-hidden="true">&rsaquo;</span>';
      }
      gPanel.hidden = !shown;
    };
    if (gUp) gUp.addEventListener('click', function () { if (gNext) gNext.click(); });
    /* linhas de brinde para N unidades do produto: cada brinde vale a partir do menor kit da lista dele */
    var giftLines = function (units, origem) {
      var out = [];
      if (!gPanel) return out;
      gPanel.querySelectorAll('[data-gf-items]').forEach(function (it) {
        var min = +it.dataset.gfMin || 0; if (!min || units < min) return;
        String(it.dataset.gfItems || '').split(',').forEach(function (pair) {
          var a = pair.split(':'); var id = +a[0], n = +a[1] || 1; if (!id) return;
          out.push({ id: id, quantity: n, properties: { _brinde: String(min), _brinde_de: handle, _origem: origem } });
        });
      });
      return out;
    };
    var set = function (id, n) {
      var r = rows.filter(function (x) { return x.dataset.pkId === id; })[0]; if (!r) return;
      n = Math.max(0, n);
      if (n * per > maxU) n = Math.floor(maxU / per);
      if (n) q[id] = n; else delete q[id];
    };
    /* encher ou esvaziar até o total do kit: tira do fim da lista e soma em rodízio */
    var avail = rows.filter(function (r) { return !r.hasAttribute('data-off'); });
    var fit = function (target) {
      var tot = function () { var u = 0; rows.forEach(function (r) { u += (q[r.dataset.pkId] || 0) * per; }); return u; };
      var guard = 0, i = avail.length - 1;
      while (i >= 0 && tot() > target && guard++ < 500) { var id = avail[i].dataset.pkId; if ((q[id] || 0) > 0) set(id, q[id] - step); else i--; }
      var start = 0; avail.forEach(function (r, ix) { if (q[r.dataset.pkId]) start = ix + 1; });
      var j = 0, before;
      while (avail.length && tot() + clickU <= target && guard++ < 500) {
        var r2 = avail[(start + j) % avail.length]; before = tot();
        set(r2.dataset.pkId, (q[r2.dataset.pkId] || 0) + step); j++;
        if (tot() === before && j > avail.length) break;
      }
    };
    /* mix "sabor:unidades, sabor:unidades" (bloco Mix) */
    var applyMix = function (str) {
      q = {};
      String(str || '').split(',').forEach(function (part) {
        var a = part.split(':'); var key = podNorm(a[0]); var units = parseInt(a[1], 10) || 0; if (!key || !units) return;
        rows.forEach(function (r2) {
          if (r2.hasAttribute('data-off')) return;
          var hit = key === '*' || podNorm(r2.dataset.pkKey) === key || podNorm(r2.dataset.pkTok).indexOf(key) > -1;
          if (hit) set(r2.dataset.pkId, Math.ceil(units / per));
        });
      });
    };
    /* kit com mix próprio (bloco Mix com "kit"): abre com esses sabores; os outros, em rodízio */
    var kitFill = function () {
      var mk = Array.prototype.filter.call(root.querySelectorAll('[data-pk-mix-kit]'), function (x) { return +x.dataset.pkMixKit === curKit; })[0];
      if (mk) applyMix(mk.dataset.pkMix); else fit(curKit);
    };
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-pk-kit')) { pickKit(b); kitFill(); render(); return; }
      var r = b.closest('[data-pk-id]');
      if (r && b.hasAttribute('data-pk-inc')) { set(r.dataset.pkId, (q[r.dataset.pkId] || 0) + step); if (r.dataset.img) ui.setGallery(r.dataset.img); render(); }
      else if (r && b.hasAttribute('data-pk-dec')) { set(r.dataset.pkId, (q[r.dataset.pkId] || 0) - step); render(); }
      else if (b.hasAttribute('data-pk-clear')) { q = {}; render(); }
      else if (b.hasAttribute('data-pk-mix') && String(b.dataset.pkMix).trim() === '*' && kitPick) { q = {}; fit(curKit); render(); }
      else if (b.hasAttribute('data-pk-mix')) { applyMix(b.dataset.pkMix); render(); }
      else if (b === addBtn) add();
    });
    var busy = false;
    var add = function () {
      var ids = Object.keys(q); if (!ids.length || busy) return;
      var t = totals(); if (t.units < minU || (kitPick ? t.units !== curKit : (kits.length && kits.indexOf(t.units) < 0))) return;
      busy = true; if (err) err.hidden = true;
      addBtn.disabled = true; addBtn.classList.add('loading');
      var sp = addBtn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden');
      var origem = root.dataset.origem || 'site-pdp';
      /* invertido: a Shopify põe o último adicionado no topo, assim o carrinho fica na ordem da caixa */
      var items = ids.map(function (id) { return { id: +id, quantity: q[id], properties: { _origem: origem } }; }).reverse();
      if (gPanel) {
        var tiersG = [];
        gPanel.querySelectorAll('[data-gf-items]').forEach(function (it) {
          var mn = +it.dataset.gfMin || 0; if (!mn) return;
          var its = String(it.dataset.gfItems || '').split(',').map(function (pair) { var a = pair.split(':'); return [+a[0], +a[1] || 1]; }).filter(function (x) { return x[0]; });
          if (its.length) tiersG.push({ min: mn, items: its });
        });
        var cfgG = {}, noG = {}; cfgG[handle] = { per: per, o: origem, t: tiersG }; podGiftCfg(cfgG);
        tiersG.forEach(function (x) { noG[handle + ':' + x.min] = 0; }); podGiftNo(noG);
      }
      var base = rootUrl();
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      /* com brindes: soma o que já está no carrinho deste produto, tira os brindes antigos e põe os do total */
      var prep = !gPanel ? Promise.resolve() : fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var have = 0, upd = {}, any = false;
        (c.items || []).forEach(function (it) {
          var pr = it.properties || {};
          if (pr._brinde_de === handle) { upd[it.key] = 0; any = true; }
          else if (it.handle === handle) have += it.quantity * per;
        });
        /* brindes primeiro: a Shopify lista o último adicionado no topo, então o produto fica acima dos brindes no carrinho e na Yampi */
        items = giftLines(have + t.units, origem).concat(items);
        if (any) return podCartFetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: upd }) });
      }).catch(function () {});
      prep.then(function () {
        return podCartFetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: ids.join(','), value: t.est, name: root.dataset.title || '' } })); } catch (e2) {}
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else location.href = base + 'cart';
        })
        .catch(function () { if (err) err.hidden = false; })
        .then(function () { busy = false; addBtn.classList.remove('loading'); if (sp) sp.classList.add('hidden'); render(); });
    };
    /* ?oferta=12 na URL (ex.: card da home) abre com esse kit */
    if (kitPick) {
      var mo = location.search.match(/[?&]oferta=(\d+)/);
      var kb = mo && Array.prototype.filter.call(kitBtns, function (b) { return b.dataset.pkKit === mo[1]; })[0];
      if (kb) pickKit(kb);
    }
    /* com kit escolhido, abre com o kit cheio em rodízio de sabores (3 + 3 + 3 + 3) */
    if (kitPick && d.prefill === '1') { q = {}; kitFill(); }
    /* ?sabor=cola (card de sabor da coleção): abre o kit inteiro nesse sabor; nome exato vence o parecido */
    var msab = location.search.match(/[?&]sabor=([^&#]+)/);
    if (msab) {
      var sk = podNorm(decodeURIComponent(msab[1].replace(/\+/g, ' '))).replace(/\s+/g, '-');
      var live = rows.filter(function (r) { return !r.hasAttribute('data-off'); });
      var hitR = live.filter(function (r) { return podNorm(r.dataset.pkTok) === sk; })[0] || live.filter(function (r) { return podNorm(r.dataset.pkTok).indexOf(sk) > -1; })[0];
      if (hitR) {
        var tgt = kitPick ? curKit : Math.max(minU, tiers.length ? tiers[0].n : minU);
        q = {}; set(hitR.dataset.pkId, Math.ceil(tgt / per));
        if (hitR.dataset.img) ui.setGallery(hitR.dataset.img);
      }
    }
    render();
  }

  function initBuybox(root) {
    if (root.__podInit) return;
    root.__podInit = true;
    if (root.dataset.mode === 'yampi') return initBoxYampi(root);
    if (root.dataset.mode === 'packs') return initBoxPacks(root);
    var dataEl = root.querySelector('[data-pod-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var unit = root.dataset.unit || 'un.';
    var idInput = root.querySelector('[data-pod-id]');
    var addBtn = root.querySelector('.pod-pdp__add');
    var addLabel = root.querySelector('[data-pod-add-label]');
    var totals = root.querySelectorAll('[data-pod-total]');
    var unitLine = root.querySelector('[data-pod-unit-line]');
    var planOnce = root.querySelector('[data-pod-plan-once]');
    var saborName = root.querySelector('[data-pod-sabor-name]');
    var galMain = root.querySelector('[data-pod-gal-main]');
    var sticky = root.querySelector('[data-pod-pdp-sticky]');
    var stickySub = root.querySelector('[data-pod-sticky-sub]');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var sabores = root.querySelectorAll('[data-pod-sabor]');
    var kits = root.querySelectorAll('[data-pod-kit]');
    var kUnit = root.querySelector('[data-pod-kinfo-unit]');
    var kWas = root.querySelector('[data-pod-kinfo-was]');
    var kSave = root.querySelector('[data-pod-kinfo-save]');
    var kNote = root.querySelector('[data-pod-kinfo-note]');
    var kGift = root.querySelector('[data-pod-kinfo-gift]');
    var kGiftWrap = root.querySelector('[data-pod-kinfo-gift-wrap]');
    var segU = root.querySelectorAll('[data-pod-kit-u]');
    var sDesc = root.querySelector('[data-pod-sabor-desc]');
    var planUnit = root.querySelector('[data-pod-plan-unit]');
    var baseImg = galMain ? galMain.getAttribute('src') : '';
    var baseSrcset = galMain ? galMain.getAttribute('srcset') : '';

    var sel = { s: '', k: 0 };
    var picked = false; // a galeria só troca depois que a pessoa escolhe um sabor
    var checked = function (list) { for (var i = 0; i < list.length; i++) if (list[i].getAttribute('aria-checked') === 'true') return list[i]; return list[0] || null; };
    var cs = checked(sabores); if (cs) sel.s = cs.dataset.podSabor;
    var ck = checked(kits); if (ck) sel.k = parseInt(ck.dataset.podKit, 10) || 0;

    var find = function (s, k) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (s && v.s !== s) continue;
        if (k && v.k !== k) continue;
        return v;
      }
      return null;
    };
    // preço de referência por unidade: o kit menor disponível (para "Economize")
    var refUnit = 0;
    variants.forEach(function (v) { var u = v.p / (v.k || 1); if (!refUnit || v.k < refUnit.k) refUnit = { k: v.k, u: u }; });
    refUnit = refUnit ? refUnit.u : 0;

    var setGallery = function (src) {
      if (!galMain) return;
      if (src) { galMain.removeAttribute('srcset'); galMain.src = src; }
      else { galMain.src = baseImg; if (baseSrcset) galMain.setAttribute('srcset', baseSrcset); }
      root.querySelectorAll('[data-pod-thumb]').forEach(function (t) { t.setAttribute('aria-current', t.dataset.podThumb === galMain.src ? 'true' : 'false'); });
    };

    var render = function () {
      // cards de kit: preço do kit no sabor escolhido
      kits.forEach(function (kc) {
        var k = parseInt(kc.dataset.podKit, 10) || 0;
        var v = find(sel.s, k);
        var t = kc.querySelector('[data-pod-kit-total]'), u = kc.querySelector('[data-pod-kit-unit]'), sv = kc.querySelector('[data-pod-kit-save]');
        kc.hidden = !v;
        if (!v) return;
        if (t) t.textContent = money(v.p);
        if (u) u.textContent = money(Math.round(v.p / (v.k || 1))) + ' / ' + unit;
        if (sv) {
          var full = v.c && v.c > v.p ? v.c : (refUnit && k > 1 ? Math.round(refUnit * k) : 0);
          if (full > v.p) { sv.hidden = false; sv.textContent = money(full); } else { sv.hidden = true; sv.textContent = ''; }
        }
      });
      var cur = find(sel.s, sel.k) || find(sel.s, 0) || find('', 0);
      if (!cur) return;
      if (idInput) idInput.value = cur.id;
      totals.forEach(function (e) { e.textContent = money(cur.p); });
      if (planOnce) planOnce.textContent = money(cur.p);
      var cu = Math.round(cur.p / (cur.k || 1));
      if (planUnit) planUnit.textContent = money(cu) + '/' + unit;
      if (kUnit) {
        kUnit.textContent = money(cu);
        var full = cur.c && cur.c > cur.p ? cur.c : (refUnit && cur.k > 1 ? Math.round(refUnit * cur.k) : 0);
        var save = full > cur.p ? full - cur.p : 0;
        if (kWas) { kWas.hidden = !save; kWas.textContent = save ? money(Math.round(full / (cur.k || 1))) : ''; }
        if (kSave) { kSave.hidden = !save; kSave.textContent = save ? (root.dataset.saveLabel || 'Economize') + ' ' + money(save) : ''; }
      }
      var kc = checked(kits);
      if (kNote) { var note = kc ? kc.dataset.note || '' : ''; kNote.textContent = note ? ' · ' + note : ''; }
      if (kGift) { var gift = kc ? kc.dataset.gift || '' : ''; kGift.textContent = gift; if (kGiftWrap) kGiftWrap.hidden = !gift; }
      segU.forEach(function (el) {
        var k = parseInt(el.dataset.podKitU, 10) || 0, v = find(sel.s, k);
        el.textContent = v ? money(Math.round(v.p / (v.k || 1))) + ' ' + (root.dataset.each || 'cada') : '';
        el.classList.toggle('is-on', !!(kc && parseInt(kc.dataset.podKit, 10) === k));
      });
      if (sDesc) { var scd = checked(sabores); var dsc = scd ? scd.dataset.desc || '' : ''; sDesc.textContent = dsc; sDesc.hidden = !dsc; }
      if (unitLine) unitLine.textContent = money(Math.round(cur.p / (cur.k || 1))) + ' por ' + unit;
      if (saborName) { var scb = checked(sabores); var sbn = scb && scb.querySelector('b'); saborName.textContent = sbn ? sbn.textContent : (cur.sn || ''); }
      if (stickySub) { var scb2 = checked(sabores); var sbn2 = scb2 && scb2.querySelector('b'); var snm = sbn2 ? sbn2.textContent : (cur.sn || ''); stickySub.textContent = (kits.length && cur.k > 1 ? 'Kit ' + cur.k : '') + (snm ? (kits.length && cur.k > 1 ? ' · ' : '') + snm : ''); }
      if (addBtn) { addBtn.disabled = !cur.a; if (addLabel) addLabel.textContent = cur.a ? addBtn.dataset.label : addBtn.dataset.soldout; }
      if (picked) { var sc = checked(sabores); setGallery(cur.img || (sc && sc.dataset.img) || ''); }
    };

    sabores.forEach(function (b) {
      b.addEventListener('click', function () {
        sabores.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        sel.s = b.dataset.podSabor;
        picked = true;
        // se o kit atual não existe nesse sabor, cai para o primeiro que existe
        if (sel.k && !find(sel.s, sel.k)) { var f = find(sel.s, 0); if (f) { sel.k = f.k; kits.forEach(function (x) { x.setAttribute('aria-checked', String(parseInt(x.dataset.podKit, 10) === f.k)); }); } }
        render();
      });
    });
    kits.forEach(function (b) {
      b.addEventListener('click', function () {
        kits.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
        sel.k = parseInt(b.dataset.podKit, 10) || 0;
        render();
      });
    });
    root.querySelectorAll('[data-pod-thumb]').forEach(function (t) { t.addEventListener('click', function () { setGallery(t.dataset.podThumb); }); });
    root.querySelectorAll('[data-pod-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        root.querySelectorAll('[data-pod-plan]').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true');
      });
    });
    var stickyBtn = root.querySelector('[data-pod-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var top = root.getBoundingClientRect().top + window.pageYOffset - 8;
      window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    if (sticky && form) {
      var tick = false;
      var upd = function () { tick = false; sticky.classList.toggle('show', form.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
      upd();
    }
    /* ?oferta=7 na URL (card da coleção, feed) abre com esse kit */
    var mof = location.search.match(/[?&]oferta=(\d+)/);
    var kof = mof && Array.prototype.filter.call(kits, function (b) { return b.dataset.podKit === mof[1]; })[0];
    if (kof) { kits.forEach(function (x) { x.setAttribute('aria-checked', 'false'); }); kof.setAttribute('aria-checked', 'true'); sel.k = parseInt(kof.dataset.podKit, 10) || 0; }
    render();
  }

  /* ---------- vídeos: play por clique, "ver mais" no mobile ---------- */
  function initUgc(root) {
    if (root.__podInit) return;
    root.__podInit = true;
    root.querySelectorAll('[data-pod-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.dataset.podVideo; if (!src) return;
        root.querySelectorAll('video').forEach(function (v) { v.pause(); });
        var v = document.createElement('video');
        v.src = src; v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.className = 'pod-ugc__video';
        var poster = b.querySelector('img'); if (poster) v.poster = poster.src;
        b.replaceWith(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
    var more = root.querySelector('[data-pod-ugc-more]');
    if (more) more.addEventListener('click', function () { root.classList.add('is-open'); more.hidden = true; });
  }

  /* ---------- avaliações: abas por tema + ver mais ---------- */
  function initReviews(root) {
    if (root.__podInit) return;
    root.__podInit = true;
    var per = parseInt(root.dataset.visible, 10) || 3;
    var items = Array.prototype.slice.call(root.querySelectorAll('.pod-rev__item'));
    var more = root.querySelector('[data-pod-rev-more]');
    var tabs = root.querySelectorAll('[data-pod-rev-tab]');
    var topic = '', shown = per;
    var render = function () {
      var list = items.filter(function (i) { return !topic || i.dataset.topic === topic; });
      items.forEach(function (i) { i.hidden = true; });
      list.forEach(function (i, n) { i.hidden = n >= shown; });
      if (more) more.hidden = list.length <= shown;
    };
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        topic = t.dataset.podRevTab; shown = per; render();
      });
    });
    if (more) more.addEventListener('click', function () { shown += per; render(); });
    render();
  }

  /* ---------- Monte seu kit (pod-kit) ---------- */
  function initKit(root) {
    if (root.__podInit) return;
    root.__podInit = true;
    var KEY = 'pod-kit-v1';
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-kit-line]'));
    var byId = {};
    lines.forEach(function (l) { byId[l.dataset.kitLine] = l; });
    var q = {};
    var load = function () {
      var m = location.search.match(/[?&]kit=([^&]+)/);
      if (m) {
        decodeURIComponent(m[1]).split(',').forEach(function (p) { var a = p.split(':'); if (byId[a[0]] && +a[1] > 0) q[a[0]] = Math.min(+a[1], 99); });
        return;
      }
      try { var raw = JSON.parse(localStorage.getItem(KEY) || '{}'); Object.keys(raw).forEach(function (id) { if (byId[id] && raw[id] > 0) q[id] = raw[id]; }); } catch (e) {}
    };
    var save = function () { try { localStorage.setItem(KEY, JSON.stringify(q)); } catch (e) {} };
    var d = root.dataset;
    var esc = function (t) { var x = document.createElement('span'); x.textContent = t == null ? '' : t; return x.innerHTML; };
    var itemsEl = root.querySelector('[data-kit-items]');
    var emptyEl = root.querySelector('[data-kit-empty]');
    var addBtns = root.querySelectorAll('[data-kit-add]');
    var err = root.querySelector('[data-kit-err]');
    var goto = root.querySelector('[data-kit-goto]');
    var scrim = root.querySelector('[data-kit-scrim]');

    /* unidades de carrinho por produto, para a faixa da Yampi de cada um */
    var perProduct = function () {
      var u = {};
      lines.forEach(function (l) { var n = q[l.dataset.kitLine] || 0; if (n && l.dataset.h) u[l.dataset.h] = (u[l.dataset.h] || 0) + n * (+l.dataset.step || 1); });
      return u;
    };
    var linePrice = function (l, pu) {
      var full = +l.dataset.price, vp = +l.dataset.vprice || 0, st = +l.dataset.step || 1;
      var u = l.dataset.h && vp ? podUnitAt(l.dataset.h, pu[l.dataset.h] || 0, vp) : null;
      return u && u < vp ? u * st : full;
    };
    var render = function () {
      var count = 0, units = 0, total = 0, html = '', full = 0;
      var pu = perProduct();
      lines.forEach(function (l) {
        var n = q[l.dataset.kitLine] || 0, per = +l.dataset.per || 1;
        l.querySelector('[data-kit-qty]').textContent = n * per;
        var uEl = l.querySelector('[data-kit-unit]'), wEl = l.querySelector('[data-kit-was]');
        var vc0 = +l.dataset.vcompare || 0;
        if (uEl) {
          var vp0 = +l.dataset.vprice || 0, st0 = +l.dataset.step || 1;
          var uu = l.dataset.h && vp0 ? podUnitAt(l.dataset.h, pu[l.dataset.h] || 0, vp0) : null;
          var cut = uu && uu < vp0;
          /* riscado: preço sem a faixa, ou o "de" do produto (Monte seu kit: preço normal da unidade) */
          var was = cut ? vp0 : (vc0 > vp0 ? vc0 : 0);
          var t1 = money(Math.round((cut ? uu : vp0) * st0 / per));
          if (uEl.textContent !== t1) uEl.textContent = t1;
          if (wEl) { var t0 = was ? money(Math.round(was * st0 / per)) : ''; if (wEl.textContent !== t0) wEl.textContent = t0; wEl.hidden = !was; }
        }
        l.classList.toggle('is-on', n > 0);
        if (n > 0) l.classList.remove('is-more');
        var dec = l.querySelector('[data-kit-dec]'); if (dec) dec.disabled = n < 1;
        if (!n) return;
        full += n * Math.max(+l.dataset.price, vc0 * (+l.dataset.step || 1));
        var price = linePrice(l, pu);
        count += n; units += n * (+l.dataset.per || 1); total += n * price;
        var th = l.dataset.img ? '<img src="' + esc(l.dataset.img) + '" width="36" height="36" alt="">' : '<span style="background:' + esc(l.dataset.color || '#E6E0DA') + '"></span>';
        html += '<li class="pod-kit__it" data-id="' + l.dataset.kitLine + '"><span class="pod-kit__ith">' + th + '</span><div class="pod-kit__itn"><b>' + esc(l.dataset.name) + '</b><span>' + esc(l.dataset.line) + (l.dataset.short ? ' · ' + esc(l.dataset.short) : '') + '</span><button type="button" data-kit-rm>' + esc(root.dataset.remove || 'Remover') + '</button></div>' +
          '<div class="pod-kit__st pod-kit__st--sm"><button type="button" data-kit-dec aria-label="−">&minus;</button><span>' + (n * (+l.dataset.per || 1)) + '</span><button type="button" data-kit-inc aria-label="+">+</button></div><b class="pod-kit__itt">' + money(n * price) + '</b></li>';
      });
      var cl = units + ' ' + (units === 1 ? d.one : d.many);
      root.querySelectorAll('[data-kit-count]').forEach(function (e) { e.textContent = cl; });
      root.querySelectorAll('[data-kit-total]').forEach(function (e) { e.textContent = money(total); });
      root.querySelectorAll('[data-kit-save]').forEach(function (e) { e.textContent = full > total ? String(d.save || 'Você economiza {v}').replace('{v}', money(full - total)) : ''; e.hidden = !(full > total); });
      root.querySelectorAll('[data-kit-hint]').forEach(function (e) { e.textContent = count ? units + ' ' + d.units + (d.hint ? ' · ' + d.hint + ' ▴' : '') : d.empty; });
      root.querySelectorAll('[data-kit-sum]').forEach(function (e) { e.textContent = count ? money(total) + ' · ' + units + ' ' + d.units : d.empty; });
      if (itemsEl) itemsEl.innerHTML = html;
      var thumbs = root.querySelector('[data-kit-thumbs]');
      if (thumbs) {
        var on = lines.filter(function (l) { return q[l.dataset.kitLine]; });
        thumbs.innerHTML = on.slice(0, 3).map(function (l) {
          var n = q[l.dataset.kitLine];
          var th = l.dataset.img ? '<img src="' + esc(l.dataset.img) + '" width="32" height="32" alt="">' : '<i style="background:' + esc(l.dataset.color || '#E6E0DA') + '"></i>';
          var nu = n * (+l.dataset.per || 1);
          return '<span class="pod-kit__tb">' + th + (nu > 1 ? '<em>' + nu + '</em>' : '') + '</span>';
        }).join('') + (on.length > 3 ? '<span class="pod-kit__tb pod-kit__tb--more">+' + (on.length - 3) + '</span>' : '');
      }
      if (emptyEl) emptyEl.hidden = count > 0;
      addBtns.forEach(function (b) { b.disabled = !count; });
      if (goto) { var base = d.page || '/pages/monte-seu-kit'; var qs = Object.keys(q).map(function (id) { return id + ':' + q[id]; }).join(','); goto.href = base + (qs ? '?kit=' + encodeURIComponent(qs) : ''); }
      root.classList.toggle('has-items', count > 0);
      root.querySelectorAll('[data-kit-clear]').forEach(function (e) { e.hidden = !count; });
      root.querySelectorAll('.pod-kit__win').forEach(function (w) { var wc = w.querySelector('[data-kit-clear-win]'); if (!wc) return; var has = Array.prototype.some.call(w.querySelectorAll('[data-kit-line]'), function (l) { return q[l.dataset.kitLine]; }); wc.hidden = !has; });
      /* quem quiser acompanhar o kit (barra de brindes da Black) ouve este evento */
      try { document.dispatchEvent(new CustomEvent('pod:kit-change', { detail: { root: root, total: total, full: full, units: units, count: count } })); } catch (e) {}
    };
    /* preencher o kit de fora (Black Boxes, atalhos): detail.items = { idDaVariante: unidades }; set substitui, add soma */
    var fill = function (items, additive) {
      if (!additive) q = {};
      Object.keys(items || {}).forEach(function (id) {
        var l = byId[id]; if (!l) return;
        var st = +l.dataset.step || 1, n = Math.max(0, Math.round((+items[id] || 0) / st));
        var v = (additive ? (q[id] || 0) : 0) + n; v = Math.min(99, v);
        if (v) q[id] = v; else delete q[id];
      });
      save(); render();
    };
    document.addEventListener('pod:kit-set', function (e) { if (!e.detail || (e.detail.root && e.detail.root !== root)) return; fill(e.detail.items, false); });
    document.addEventListener('pod:kit-add', function (e) { if (!e.detail || (e.detail.root && e.detail.root !== root)) return; fill(e.detail.items, true); });
    var set = function (id, delta) {
      var n = Math.max(0, Math.min(99, (q[id] || 0) + delta));
      if (n) q[id] = n; else delete q[id];
      save(); render();
    };
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button,a'); if (!t || !root.contains(t)) return;
      var host = t.closest('[data-kit-line],[data-id]');
      var id = host ? (host.dataset.kitLine || host.dataset.id) : null;
      if (t.hasAttribute('data-kit-inc') && id) set(id, 1);
      else if (t.hasAttribute('data-kit-dec') && id) set(id, -1);
      else if (t.hasAttribute('data-kit-rm') && id) set(id, -(q[id] || 0));
      else if (t.hasAttribute('data-kit-open')) { root.classList.add('is-open'); if (scrim) scrim.hidden = false; }
      else if (t.hasAttribute('data-kit-close')) { root.classList.remove('is-open'); if (scrim) scrim.hidden = true; }
      else if (t.hasAttribute('data-kit-toggle')) {
        var w = t.closest('.pod-kit__win'); var c = w.classList.toggle('is-collapsed');
        t.setAttribute('aria-expanded', String(!c)); t.textContent = c ? t.dataset.show : t.dataset.hide;
      } else if (t.hasAttribute('data-kit-tab')) {
        root.querySelectorAll('[data-kit-tab]').forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        root.querySelectorAll('.pod-kit__win').forEach(function (w) { w.hidden = w.dataset.win !== t.dataset.kitTab; });
      } else if (t.hasAttribute('data-kit-add')) add(t);
      else if (t.hasAttribute('data-kit-more')) { var wm = t.closest('.pod-kit__win'); if (wm) wm.querySelectorAll('.pod-kit__ln.is-more').forEach(function (l) { l.classList.remove('is-more'); }); t.remove(); }
      else if (t.hasAttribute('data-kit-clear')) { q = {}; save(); render(); }
      else if (t.hasAttribute('data-kit-clear-win')) { var cw = t.closest('.pod-kit__win'); if (cw) { cw.querySelectorAll('[data-kit-line]').forEach(function (l) { delete q[l.dataset.kitLine]; }); save(); render(); } }
    });
    if (scrim) scrim.addEventListener('click', function () { root.classList.remove('is-open'); scrim.hidden = true; });
    var busy = false;
    var add = function (btn) {
      var ids = Object.keys(q); if (!ids.length || busy) return;
      busy = true; if (err) err.hidden = true;
      addBtns.forEach(function (b) { b.disabled = true; b.classList.add('loading'); });
      var items = ids.map(function (id) { return { id: +id, quantity: q[id] * (+byId[id].dataset.step || 1), properties: { _origem: d.origem || 'monte-seu-kit' } }; }).reverse();
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      podCartFetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          var pu = perProduct(), value = 0; ids.forEach(function (id) { value += q[id] * linePrice(byId[id], pu); });
          try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: ids.join(','), value: value, name: 'Monte seu kit' } })); } catch (e) {}
          q = {}; save(); render();
          root.classList.remove('is-open'); if (scrim) scrim.hidden = true;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else location.href = root_url + 'cart';
        })
        .catch(function () { if (err) err.hidden = false; })
        .then(function () { busy = false; addBtns.forEach(function (b) { b.classList.remove('loading'); }); render(); });
    };
    load();
    var firstTab = root.querySelector('[data-kit-tab]'); if (firstTab) firstTab.click();
    render();
  }

  /* ---------- gaveta: preço do checkout (faixas e brindes) e brindes sem a quantidade mínima ---------- */
  var drawerBusy = false;
  function drawerEnhance() {
    var drawer = document.querySelector('cart-drawer'); if (!drawer) return;
    var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-pod-h]'));
    var est = drawer.querySelector('[data-pod-est]');
    var units = {};
    rows.forEach(function (r) { if (!r.dataset.podG) units[r.dataset.podH] = (units[r.dataset.podH] || 0) + (+r.dataset.podQ || 0); });
    var total = 0, full = 0, shop = 0, shopAdj = 0, any = false, drop = {};
    var cfg = Object.assign({}, podGiftGlobal(), podGiftCfg());
    /* valor dos produtos (sem brindes) pelo preço que a Yampi cobra: base das regras por valor (escada da Black) */
    var cartValOf = function (prefix) {
      var v = 0;
      rows.forEach(function (r) {
        if (r.dataset.podG || (prefix && String(r.dataset.podH || '').indexOf(prefix) !== 0)) return;
        var qn = +r.dataset.podQ || 0, pr = +r.dataset.podP || 0;
        var u = podUnitAt(r.dataset.podH, units[r.dataset.podH] || 0, pr);
        v += qn * (u && u < pr ? u : pr);
      });
      return v;
    };
    /* regra com v:1 conta o valor em centavos; h = prefixo do handle que entra na conta (ex.: "black-"); sem h, o carrinho inteiro */
    var cartVal = cartValOf('');
    rows.forEach(function (r) {
      var qn = +r.dataset.podQ || 0, pr = +r.dataset.podP || 0, line = qn * pr, txt = '';
      full += line; shop += line; shopAdj += line;
      if (r.dataset.podG) {
        var min = +r.dataset.podG || 0, de = r.dataset.podGde || '';
        var byVal = cfg[de] && cfg[de].v;
        if ((byVal ? cartValOf(cfg[de].h || '') : (units[de] || 0)) >= min) {
          txt = byVal ? 'Brinde da Black' : 'Brinde da oferta'; any = true;
          /* latinhas da Black saem a R$ 1 na Yampi (não R$ 0): entram no total e o total da Shopify já desconta os R$ 13 (cart-drawer.liquid) */
          if (de === 'black') { total += qn * 100; shopAdj -= qn * (pr - 100); }
        }
        else { drop[r.dataset.podKey] = 0; total += line; }
      } else {
        var u = podUnitAt(r.dataset.podH, units[r.dataset.podH] || 0, pr), cp = +r.dataset.podC || 0;
        if (u && u < pr) { total += qn * u; if (cp > pr) full += qn * (cp - pr); txt = money(Math.round(u)) + ' cada com desconto'; any = true; }
        else if (cp > pr) { total += line; full += qn * (cp - pr); txt = 'De ' + money(cp) + ' por ' + money(pr) + ' cada'; any = true; }
        else total += line;
      }
      var note = r.querySelector('[data-pod-li-est]');
      if (note) { if (note.textContent !== txt) note.textContent = txt; note.hidden = !txt; }
    });
    if (est) {
      total = Math.round(total);
      var h = any && total < full ? (total < shopAdj ? 'Total com desconto: <b>' + money(total) + '</b> ' : '') + '<span>Você economiza ' + money(full - total) + '</span>' : '';
      /* escada por valor: próximo brinde */
      Object.keys(cfg).forEach(function (hk) {
        var c = cfg[hk]; if (!c || !c.v || !c.t) return;
        var cv = cartValOf(c.h || ''); if (!cv) return;
        var next = null; c.t.forEach(function (t) { if (cv < t.min && (!next || t.min < next.min)) next = t; });
        if (next && next.n && !drawer.querySelector('[data-pod-ladder]')) h += (h ? '<br>' : '') + '<span class="pod-drawer-next">Faltam ' + money(next.min - cv) + ' para ganhar ' + next.n + '</span>';
      });
      /* só escreve quando muda: o observador da gaveta reage a qualquer troca de nó */
      if (est.innerHTML !== h) est.innerHTML = h;
      est.hidden = !h;
      /* total da Shopify riscado só quando a Yampi cobra menos que ele (faixa ou brinde) */
      var cutS = h && total < shopAdj ? '1' : '';
      if ((est.dataset.cut || '') !== cutS) est.dataset.cut = cutS;
    }
    /* brinde que perdeu a quantidade mínima (ex.: tirou garrafas na gaveta) sai do carrinho */
    if (Object.keys(drop).length && !drawerBusy) {
      drawerBusy = true;
      podCartFetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: drop, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (res) { podDrawerShow(res); })
        .catch(function () {})
        .then(function () { drawerBusy = false; });
      return;
    }
    if (drawerBusy) return;
    var no = podGiftNo(), addG = [];
    Object.keys(cfg).forEach(function (h) {
      var c = cfg[h] || {}, n = c.v ? cartValOf(c.h || '') : (units[h] || 0) * (+c.per || 1); if (!n || !c.t) return;
      c.t.forEach(function (tier) {
        var k = h + ':' + tier.min;
        if (n < tier.min) { delete giftTried[k]; return; }
        if (no[k] || giftTried[k]) return;
        var has = rows.some(function (r) { return r.dataset.podGde === h && +r.dataset.podG === tier.min; });
        if (has) return;
        giftTried[k] = true;
        tier.items.forEach(function (x) { addG.push({ id: x[0], quantity: x[1], properties: { _brinde: String(tier.min), _brinde_de: h, _origem: c.o || 'site-gaveta' } }); });
      });
    });
    if (addG.length) {
      /* um pedido por degrau: a Shopify funde variantes repetidas num mesmo add.js e perderia o degrau de baixo */
      drawerBusy = true;
      var groups = {}; addG.forEach(function (x) { var k = x.properties._brinde_de + ':' + x.properties._brinde; (groups[k] = groups[k] || []).push(x); });
      var chain = Promise.resolve(null);
      Object.keys(groups).forEach(function (k) {
        chain = chain.then(function () {
          return podCartFetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: groups[k], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) }).then(function (r) { return r.json(); });
        });
      });
      chain
        .then(function (res) { if (res && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res); })
        .catch(function () {})
        .then(function () { drawerBusy = false; });
    }
  }
  var giftTried = {};
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer'); if (!drawer || drawer.__podWatch) return;
    drawer.__podWatch = true;
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(drawerEnhance, 60); }).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-pod-clear]');
      if (clr) {
        e.preventDefault();
        if (!clr.classList.contains('is-armed')) {
          clr.classList.add('is-armed'); clr.dataset.label = clr.dataset.label || clr.textContent; clr.textContent = clr.dataset.confirm || 'Toque de novo para limpar';
          clearTimeout(clr.__t); clr.__t = setTimeout(function () { clr.classList.remove('is-armed'); clr.textContent = clr.dataset.label; }, 4000);
          return;
        }
        clr.disabled = true;
        var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        podCartFetch(rootUrl() + 'cart/clear.js', { method: 'POST', headers: J })
          .then(function () { return podCartFetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) }); })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            try { window.sessionStorage.removeItem('podBrindesNao'); } catch (e2) {}
            if (res && res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
            if (!res || !res.item_count) { drawer.classList.add('is-empty'); var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.add('is-empty'); }
            try { document.dispatchEvent(new CustomEvent('pod:cart-cleared')); } catch (e3) {}
          })
          .catch(function () { clr.disabled = false; });
        return;
      }
      var up = e.target.closest('[data-pod-up]');
      if (up) {
        e.preventDefault(); if (up.disabled) return; up.disabled = true; var upl = up.textContent; up.textContent = '...';
        var ua = String(up.dataset.podUp || '').split(':');
        podCartFetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +ua[0], quantity: +ua[1] || 1, properties: { _origem: 'black-carrinho' } }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw res;
            var upv = 0; try { (res.items || []).forEach(function (it) { upv += it.final_line_price || it.line_price || 0; }); } catch (e5) {}
            try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: ua[0], value: upv, name: up.dataset.podUpName || '' } })); } catch (e4) {}
            if (res && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res);
          })
          .catch(function () { up.disabled = false; up.textContent = upl; });
        return;
      }
      var bx = e.target.closest('[data-pod-box-rm]');
      if (bx) {
        e.preventDefault(); bx.disabled = true;
        var upd = {}; String(bx.dataset.podBoxRm || '').split(',').forEach(function (k) { if (k) upd[k] = 0; });
        podCartFetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res);
            if (!res || !res.item_count) { drawer.classList.add('is-empty'); var inn = drawer.querySelector('.drawer__inner'); if (inn) inn.classList.add('is-empty'); }
            try { document.dispatchEvent(new CustomEvent('pod:cart-changed')); } catch (e3) {}
          })
          .catch(function () { bx.disabled = false; });
        return;
      }
      var rm = e.target.closest('cart-remove-button'); var row = rm && rm.closest('[data-pod-g]'); if (!row) return;
      var no = {}; no[(row.dataset.podGde || '') + ':' + row.dataset.podG] = 1; podGiftNo(no);
    }, true);
    drawerEnhance();
  }

  /* ---------- Black November: contagem, barra da escada, Black Boxes e atalhos do espumante ---------- */
  var blackCart = 0, blackCartLoaded = false;
  function fetchBlackCart(cb) {
    fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var v = 0; (c.items || []).forEach(function (it) { if (!(it.properties && it.properties._brinde) && String(it.handle || '').indexOf('black-') === 0) v += it.final_line_price; });
      blackCart = v; blackCartLoaded = true; if (cb) cb();
    }).catch(function () { if (cb) cb(); });
  }
  function initBlack(root) {
    if (root.__podBlack) return;
    root.__podBlack = true;
    var tiers = String(root.dataset.tiers || '').split(';').map(function (x) { var a = x.split('|'); return { min: +a[0], n: a[1] || '' }; }).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
    var fill = root.querySelector('[data-black-fill]'), msg = root.querySelector('[data-black-msg]');
    var top = tiers.length ? tiers[tiers.length - 1].min : 0;
    var kitTotal = 0, kitFull = 0;
    var paint = function () {
      if (!tiers.length) return; /* topo sem escada (ela está na section "escada"): nada a pintar aqui */
      var v = kitTotal + blackCart;
      if (fill && top) fill.style.width = Math.min(100, v / top * 100) + '%';
      root.querySelectorAll('[data-black-tick]').forEach(function (t) { t.style.left = Math.min(100, (+t.dataset.blackTick) / top * 100) + '%'; t.classList.toggle('is-on', v >= +t.dataset.blackTick); });
      root.querySelectorAll('[data-black-tier]').forEach(function (t) { var on = v >= +t.dataset.blackTier; t.classList.toggle('is-on', on); t.classList.toggle('is-locked', !on); });
      var next = null; tiers.forEach(function (t) { if (v < t.min && !next) next = t; });
      var text = !v ? (root.dataset.first || '') : next ? String(root.dataset.missing || '').replace('{v}', money(next.min - v)).replace('{b}', next.n) : (root.dataset.done || '');
      if (msg) { msg.textContent = text; msg.classList.toggle('is-done', !!v && !next); }
      var nxt = next && kitTotal ? String(root.dataset.missing || '').replace('{v}', money(next.min - v)).replace('{b}', next.n) : (kitTotal && !next ? (root.dataset.done || '') : '');
      /* versão curta para a barra flutuante */
      var shortN = next ? String(next.n).replace(/^mais /, '+').replace(' secretas', '') : '';
      var nxtS = next && kitTotal ? 'faltam ' + money(next.min - v) + ' para ' + shortN : (kitTotal && !next ? 'todos os brindes liberados' : '');
      var econS = kitFull > kitTotal ? 'Economiza ' + money(kitFull - kitTotal) + ' · ' : '';
      /* "quase lá": a linha que fecha o próximo degrau gastando menos (prefere o que já está no kit) */
      var sug = null;
      if (next && kitTotal) {
        var gap = next.min - v;
        /* só a janela em destaque (espumante): o que o Leo quer empurrar na Black */
        var cands = document.querySelectorAll('[data-pod-kit-root] .pod-kit__win[data-win="1"] [data-kit-line]');
        if (!cands.length) cands = document.querySelectorAll('[data-pod-kit-root] [data-kit-line]');
        cands.forEach(function (l) {
          var vp = +l.dataset.vprice || 0, st = +l.dataset.step || 1, per = +l.dataset.per || st; if (!vp || l.hasAttribute('data-soldout')) return;
          var tap = vp * st, n = Math.ceil(gap / tap), cost = n * tap, on = l.classList.contains('is-on') ? 1 : 0;
          if (!sug || cost < sug.cost || (cost === sug.cost && on > sug.on)) sug = { id: l.dataset.kitLine, n: n, units: n * per, cost: cost, on: on, name: l.dataset.name || '', step: st };
        });
      }
      /* escada na barra flutuante do kit */
      var lad = document.querySelector('.pod-kit__bar .pod-kit__ladder');
      if (lad && top) {
        var lf = lad.querySelector('i'); if (lf) lf.style.width = Math.min(100, v / top * 100) + '%';
        lad.querySelectorAll('b').forEach(function (t) { t.classList.toggle('is-on', v >= +t.dataset.min); });
      }
      document.querySelectorAll('[data-kit-next]').forEach(function (e) {
        var bar = e.getAttribute('data-kit-next') === 'bar';
        e.textContent = nxt ? (bar ? econS + nxtS : nxt) : ''; e.hidden = !e.textContent;
        if (!bar && sug && e.textContent) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'pod-kit__fillbtn';
          b.textContent = 'Completar: +' + sug.units + ' ' + sug.name + ' por ' + money(sug.cost);
          b.setAttribute('data-kit-fill', sug.id + ':' + (sug.n * sug.step));
          e.appendChild(document.createTextNode(' ')); e.appendChild(b);
        }
      });
      /* parcelamento no resumo do kit */
      var parcel = document.querySelector('[data-kit-parcel]');
      if (parcel) { var nP = +parcel.dataset.kitParcel || 3; parcel.textContent = kitTotal >= 3000 ? 'ou ' + nP + 'x de ' + money(Math.round(kitTotal / nP)) + ' sem juros no cartão' : ''; parcel.hidden = !parcel.textContent; }
    };
    document.addEventListener('pod:kit-change', function (e) { kitTotal = e.detail.total || 0; kitFull = e.detail.full || 0; paint(); });
    document.addEventListener('pod:add', function () { setTimeout(function () { fetchBlackCart(paint); }, 800); });
    document.addEventListener('pod:cart-cleared', function () { blackCart = 0; paint(); });
    document.addEventListener('pod:cart-changed', function () { fetchBlackCart(paint); });
    fetchBlackCart(paint);
    /* contagem regressiva até a data real */
    var end = Date.parse(root.dataset.end || ''), cnt = root.querySelector('[data-black-count]'), ended = root.querySelector('[data-black-ended]');
    if (end && cnt) {
      var two = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { cnt.hidden = true; if (ended) ended.hidden = false; return; }
        cnt.hidden = false;
        var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), sec = Math.floor(left % 6e4 / 1e3);
        var set = function (k, v) { var el = cnt.querySelector('[data-cd="' + k + '"]'); if (el && el.textContent !== v) el.textContent = v; };
        set('d', String(d)); set('h', two(h)); set('m', two(m)); set('s', two(sec));
        setTimeout(tick, 1000);
      };
      tick();
    }
    /* carrossel das Black Boxes no celular: posição e bolinhas */
    document.querySelectorAll('[data-bbox-track]').forEach(function (track) {
      var nav = track.parentNode.querySelector('[data-bbox-nav]'); if (!nav) return;
      var pos = nav.querySelector('[data-bbox-pos]'), dots = nav.querySelectorAll('[data-bbox-dots] i');
      var upd = function () {
        var cards = track.children; if (!cards.length) return;
        var w = cards[0].getBoundingClientRect().width + 12, i = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
        if (pos) pos.textContent = String(i + 1);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
    /* linha do próximo brinde no resumo do kit e atalhos +4/+8/+12 na primeira janela (espumante) */
    var kit = document.querySelector('[data-pod-kit-root]');
    if (kit) {
      /* âncora estável para os botões "Montar meu kit" (o id da section muda por template) */
      if (!document.getElementById('kit')) kit.id = 'kit';
      /* etiqueta de % off em cada janela (primeira linha com "de") */
      kit.querySelectorAll('.pod-kit__win').forEach(function (w) {
        var l = w.querySelector('[data-kit-line]'); if (!l) return;
        var vp = +l.dataset.vprice || 0, vc = +l.dataset.vcompare || 0; if (!(vc > vp && vp)) return;
        var pct = Math.round((vc - vp) / vc * 100); if (pct < 1 || w.querySelector('.pod-kit__pct')) return;
        var tag = document.createElement('span'); tag.className = 'pod-kit__pct'; tag.textContent = pct + '% off';
        var host = w.querySelector('.pod-kit__wh b'); if (host) host.appendChild(tag);
      });
      /* linha de economia e próximo brinde também na barra flutuante */
      var barTx = kit.querySelector('.pod-kit__bartx');
      if (barTx && !barTx.querySelector('[data-kit-next]')) { var bn = document.createElement('span'); bn.className = 'pod-kit__next'; bn.setAttribute('data-kit-next', 'bar'); bn.hidden = true; barTx.appendChild(bn); }
      if (barTx && tiers.length && !barTx.querySelector('.pod-kit__ladder')) {
        var ld = document.createElement('span'); ld.className = 'pod-kit__ladder'; ld.setAttribute('aria-hidden', 'true');
        var topv = tiers[tiers.length - 1].min; var inner = '<i></i>';
        tiers.forEach(function (t) { inner += '<b data-min="' + t.min + '" style="left:' + Math.min(100, t.min / topv * 100) + '%"></b>'; });
        ld.innerHTML = inner; barTx.appendChild(ld);
      }
      /* barra fixa do kit escondida enquanto o kit está vazio e ainda não apareceu na tela */
      var kitCount = 0, prekit = function () {
        var r = kit.getBoundingClientRect();
        document.documentElement.classList.toggle('pod-black-prekit', !kitCount && r.top > window.innerHeight - 120);
      };
      document.addEventListener('pod:kit-change', function (e) { kitCount = e.detail.count || 0; prekit(); });
      window.addEventListener('scroll', function () { window.requestAnimationFrame(prekit); }, { passive: true });
      prekit();
      var save = kit.querySelector('[data-kit-save]');
      if (save && !kit.querySelector('[data-kit-next=""]')) { var nx = document.createElement('p'); nx.className = 'pod-kit__next'; nx.setAttribute('data-kit-next', ''); nx.hidden = true; save.parentNode.insertBefore(nx, save.nextSibling); }
      if (save && !kit.querySelector('[data-kit-parcel]')) { var pc = document.createElement('p'); pc.className = 'pod-kit__parcel'; pc.setAttribute('data-kit-parcel', kit.dataset.parcel || '3'); pc.hidden = true; save.parentNode.insertBefore(pc, save); }
      var w1 = kit.querySelector('.pod-kit__win[data-win="1"]');
      if (w1 && !w1.querySelector('.pod-kit__quick')) {
        var ls = Array.prototype.slice.call(w1.querySelectorAll('[data-kit-line]'));
        if (ls.length) {
          var box = document.createElement('div'); box.className = 'pod-kit__quick';
          [4, 8, 12].forEach(function (n) {
            var b = document.createElement('button'); b.type = 'button'; b.textContent = '+' + n + ' garrafas';
            b.addEventListener('click', function () {
              var items = {}; var per = Math.max(1, Math.round(n / ls.length));
              ls.forEach(function (l, i) { if (i * per < n) items[l.dataset.kitLine] = Math.min(per, n - i * per) * (+l.dataset.step || 1); });
              document.dispatchEvent(new CustomEvent('pod:kit-add', { detail: { items: items } }));
            });
            box.appendChild(b);
          });
          var lines = w1.querySelector('.pod-kit__lines'); if (lines) lines.parentNode.insertBefore(box, lines);
        }
      }
    }
  }
  var boxBusy = false;
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-kit-fill]');
    if (f) { var a = String(f.dataset.kitFill || '').split(':'), it = {}; if (a[0] && +a[1] > 0) { it[a[0]] = +a[1]; document.dispatchEvent(new CustomEvent('pod:kit-add', { detail: { items: it } })); } return; }
    /* "Personalize": montador vazio */
    var pz = e.target.closest('[data-black-personalize]');
    if (pz) {
      document.dispatchEvent(new CustomEvent('pod:kit-set', { detail: { items: {} } }));
      var tz = document.querySelector(pz.dataset.target || '#kit'); if (tz) tz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var b = e.target.closest('[data-black-box]'); if (!b) return;
    var items = {}; String(b.dataset.blackBox || '').split(',').forEach(function (p) { var a = p.split(':'); if (a[0] && +a[1] > 0) items[a[0]] = +a[1]; });
    if (b.dataset.boxMode !== 'cart') {
      document.dispatchEvent(new CustomEvent('pod:kit-set', { detail: { items: items } }));
      var t = document.querySelector(b.dataset.target || '#kit'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    /* box fixa direto no carrinho: cada item leva _box (id) e _box_name; a gaveta agrupa e tira a box inteira de uma vez */
    if (boxBusy) return; boxBusy = true;
    var label = b.textContent, boxId = b.dataset.boxId || 'box'; b.disabled = true; b.textContent = 'Adicionando...';
    var lines = Object.keys(items).map(function (id) { return { id: +id, quantity: items[id], properties: { _box: boxId, _box_name: b.dataset.boxName || 'Black Box', _origem: 'black-box' } }; });
    var rootU = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* box já no carrinho: segundo clique só abre a gaveta (não dobra a box); brindes pelo valor real do carrinho */
    podCartHasBox(boxId)
      .then(function (has) {
        if (has) return null;
        return podCartFetch(rootU + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw res;
            var value = 0; lines.forEach(function (l) { var ln = document.querySelector('[data-kit-line="' + l.id + '"]'); if (ln) value += l.quantity * (+ln.dataset.vprice || 0); });
            try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: Object.keys(items).join(','), value: value, name: b.dataset.boxName || 'Black Box' } })); } catch (e2) {}
            return res;
          });
      })
      .then(function () { return podGiftSyncByValue(); })
      .then(function () { return podCartSections(); })
      .then(function (res) { if (!podDrawerShow(res)) location.href = rootU + 'cart'; })
      .catch(function () { label = 'Não deu. Tente de novo'; })
      .then(function () { boxBusy = false; b.disabled = false; b.textContent = label; });
  });


  /* ---------- Black, versão B: galeria + seletor de box + resumo + comprar agora ---------- */
  function initBlackOferta(root) {
    if (root.__podBo) return;
    root.__podBo = true;
    var tiers = String(root.dataset.tiers || '').split(';').map(function (x) { var a = x.split('|'); return { min: +a[0], n: a[1] || '' }; }).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-bo-opt]'));
    var sum = root.querySelector('[data-bo-sum]'), err = root.querySelector('[data-bo-err]');
    var q = function (sel) { return root.querySelector(sel); };
    var cur = null;
    var paint = function () {
      var o = cur; if (!o || !sum) return;
      var total = +o.dataset.total || 0, full = +o.dataset.full || 0, units = +o.dataset.units || 0;
      var latas = +o.dataset.latas || 0, ship = o.dataset.ship === 'true', pct = +o.dataset.pct || 0;
      var name = o.dataset.boxName || 'Black Box', unit = o.dataset.unit || 'unidade';
      var unitsTxt = units + ' ' + (units === 1 ? unit : unit + 's');
      /* preço pago = produtos + latinhas (R$ 1 cada na Yampi, por causa do ERP); o cliente vê só o desconto já com isso dentro */
      var tot = +o.dataset.pay || (total + latas * 100);
      sum.hidden = false;
      q('[data-bo-name]').textContent = name + ' · ' + unitsTxt;
      q('[data-bo-full]').textContent = money(full);
      var pc0 = q('[data-bo-pct]'); if (pc0) pc0.textContent = (pct || Math.round((full - tot) * 100 / (full || 1))) + '%';
      q('[data-bo-save]').textContent = full > tot ? '− ' + money(full - tot) : money(0);
      var gr = q('[data-bo-giftrow]'), sr = q('[data-bo-shiprow]');
      if (gr) { gr.hidden = !latas; var gt = q('[data-bo-gifts]'); if (gt) gt.textContent = latas + ' latinhas secretas · ' + money(latas * 1000) + ' em brindes'; }
      if (sr) sr.hidden = !ship;
      q('[data-bo-total]').textContent = money(tot);
      var ut = q('[data-bo-units]'); if (ut) ut.textContent = '· ' + unitsTxt;
      var ea = q('[data-bo-each]'); if (ea) ea.textContent = units > 1 ? 'Cada ' + unit + ' sai por ' + money(Math.round(total / units)) : '';
      var pc = q('[data-bo-parcel]'); if (pc) pc.textContent = money(Math.round(tot / (+pc.dataset.n || 3)));
      var wn = q('[data-bo-withname]'); if (wn) wn.textContent = name;
      root.querySelectorAll('[data-bo-tier]').forEach(function (t) { t.classList.toggle('is-on', total >= +t.dataset.boTier); });
      var ch = q('[data-bo-chips]'); if (ch) { var cs = []; if (latas) cs.push(money(latas * 1000) + ' em brindes'); if (ship) cs.push('frete grátis'); ch.innerHTML = cs.map(function (c) { return '<span>' + c + '</span>'; }).join(''); }
      opts.forEach(function (x) { x.classList.toggle('is-on', x === o); });
    };
    opts.forEach(function (o) {
      var inp = o.querySelector('input'); if (!inp) return;
      inp.addEventListener('change', function () { if (inp.checked) { cur = o; paint(); } });
      if (inp.checked) cur = o;
    });
    if (!cur && opts.length) { cur = opts[0]; var i0 = cur.querySelector('input'); if (i0) i0.checked = true; }
    paint();
    var stk = root.querySelector('[data-bo-stk]'), mx = Math.max.apply(null, opts.map(function (o) { return +o.dataset.pct || 0; }).concat([0]));
    if (stk && mx > 0) { stk.innerHTML = '<b>' + mx + '%</b>OFF'; stk.hidden = false; }
    /* itens da box + latinhas do degrau, numa chamada só */
    var linesFor = function (o) {
      var lines = [];
      String(o.dataset.items || '').split(',').forEach(function (p) { var a = p.split(':'); if (a[0] && +a[1] > 0) lines.push({ id: +a[0], quantity: +a[1], properties: { _box: o.dataset.boxId || 'box', _box_name: o.dataset.boxName || 'Black Box', _origem: 'black-box' } }); });
      var total = +o.dataset.total || 0, cfg = podGiftGlobal().black;
      if (cfg && cfg.t) cfg.t.forEach(function (t) { if (total >= t.min && t.items) t.items.forEach(function (x) { lines.push({ id: x[0], quantity: x[1], properties: { _brinde: String(t.min), _brinde_de: 'black', _origem: cfg.o || 'black-november' } }); }); });
      return lines;
    };
    var busy = false;
    var add = function (goCheckout, btn) {
      if (!cur || busy) return; busy = true; if (err) err.hidden = true;
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adicionando...';
      var rootU = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var boxId = cur.dataset.boxId || 'box';
      /* só os itens da box; os degraus de brinde vêm do valor real do carrinho (podGiftSyncByValue), um pedido por degrau.
         Box já no carrinho (ex.: "adicionar e continuar" e depois "Comprar agora") não entra de novo. */
      var lines = linesFor(cur).filter(function (l) { return !l.properties._brinde; });
      podCartHasBox(boxId)
        .then(function (has) {
          if (has) return null;
          return podCartFetch(rootU + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines }) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) throw res;
              try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: String(cur.dataset.items || '').split(',').map(function (p) { return p.split(':')[0]; }).join(','), value: +cur.dataset.total || 0, name: cur.dataset.boxName || 'Black Box', n: +cur.dataset.units || 0, checkout: !!goCheckout } })); } catch (e2) {}
              return res;
            });
        })
        .then(function (res) {
          /* box já estava lá e o cliente quer fechar a compra: avisa o pixel do mesmo jeito */
          if (!res && goCheckout) { try { document.dispatchEvent(new CustomEvent('pod:add', { detail: { id: String(cur.dataset.items || '').split(',').map(function (p) { return p.split(':')[0]; }).join(','), value: +cur.dataset.total || 0, name: cur.dataset.boxName || 'Black Box', n: +cur.dataset.units || 0, checkout: true } })); } catch (e4) {} }
          return podGiftSyncByValue();
        })
        .then(function () {
          if (goCheckout) { location.href = rootU + 'cart'; return null; }
          return podCartSections().then(function (res) { if (!podDrawerShow(res)) location.href = rootU + 'cart'; });
        })
        .catch(function () { if (err) err.hidden = false; })
        .then(function () { busy = false; btn.disabled = false; btn.textContent = label; });
    };
    var buy = root.querySelector('[data-bo-buy]'), addb = root.querySelector('[data-bo-add]');
    if (buy) buy.addEventListener('click', function () { add(true, buy); });
    if (addb) addb.addEventListener('click', function () { add(false, addb); });
    /* barra flutuante: aparece quando o seletor já passou e o Comprar agora não está na tela; compra a box selecionada */
    var fl = root.querySelector('[data-bo-float]'), flb = root.querySelector('[data-bo-float-buy]');
    if (fl && buy) {
      var pick = root.querySelector('.pod-bo__pick'), tick = 0;
      var updFloat = function () {
        var o = root.querySelector('[data-bo-opt].is-on') || cur;
        if (o) { var n = fl.querySelector('[data-bo-fname]'), pz = fl.querySelector('[data-bo-fprice]'); if (n) n.textContent = o.dataset.boxName || 'Black Box'; if (pz) pz.textContent = money(+o.dataset.pay || 0); }
        var vh = window.innerHeight || 800, br = buy.getBoundingClientRect();
        var buyVis = br.top < vh * 0.92 && br.bottom > 0;
        var past = pick ? pick.getBoundingClientRect().top < vh * 0.6 : true;
        var show = past && !buyVis;
        if (show) fl.removeAttribute('hidden'); else fl.setAttribute('hidden', '');
        document.documentElement.classList.toggle('pod-bo-float-on', show);
      };
      var onScroll = function () { if (tick) return; tick = window.requestAnimationFrame(function () { tick = 0; updFloat(); }); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      opts.forEach(function (o) { var i = o.querySelector('input'); if (i) i.addEventListener('change', updFloat); });
      if (flb) flb.addEventListener('click', function () { add(true, flb); });
      updFloat();
    }
    /* personalizar: abre o montador como janela por cima */
    var cust = root.querySelector('[data-bo-custom]');
    if (cust) cust.addEventListener('click', function () {
      var kit = document.querySelector('[data-pod-kit-root]'); if (!kit) return;
      var sec = kit.closest('.shopify-section') || kit;
      document.documentElement.classList.add('pod-bo-custom-open');
      if (!sec.querySelector('[data-bo-close]')) {
        var cl = document.createElement('button'); cl.type = 'button'; cl.className = 'pod-bo__close'; cl.setAttribute('data-bo-close', ''); cl.setAttribute('aria-label', 'Fechar'); cl.innerHTML = '&times;';
        cl.addEventListener('click', function () { document.documentElement.classList.remove('pod-bo-custom-open'); });
        sec.insertBefore(cl, sec.firstChild);
      }
      sec.scrollTop = 0;
      try { document.dispatchEvent(new CustomEvent('pod:kit-set', { detail: { items: {} } })); } catch (e3) {}
    });
    /* galeria: miniaturas sincronizadas com o scroll */
    var track = root.querySelector('[data-bo-track]'), thumbs = root.querySelector('[data-bo-thumbs]');
    if (track) {
      var slides = track.children, n = slides.length, ths = thumbs ? Array.prototype.slice.call(thumbs.children) : [];
      var mark = function (k) { ths.forEach(function (t, j) { t.classList.toggle('is-on', j === k); }); };
      mark(0);
      ths.forEach(function (t, j) { t.addEventListener('click', function () { var w = slides[0].getBoundingClientRect().width || 1; track.scrollTo({ left: w * j, behavior: 'smooth' }); mark(j); }); });
      if (n > 1) {
        var upd = function () { var w = slides[0].getBoundingClientRect().width || 1, k = Math.min(n - 1, Math.max(0, Math.round(track.scrollLeft / w))); mark(k); };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      }
    }
  }

  /* ---------- pixel Meta do site: 1 AddToCart por clique (ou só ao finalizar compra), nos IDs configurados ---------- */
  function initPixel() {
    var cfg = window.podPixel; if (!cfg || cfg.__on) return; cfg.__on = true;
    var raw = cfg.ids || String(cfg.pixel_id || '').split(',');
    var ids = raw.map(function (x) { return String(x).trim(); }).filter(Boolean); if (!ids.length) return;
    var cur = cfg.currency || 'BRL';
    if (cfg.init || cfg.pageview) {
      !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      if (cfg.init) ids.forEach(function (id) { fbq('init', id); });
      if (cfg.pageview) fbq('track', 'PageView');
    }
    var atc = function (idList, cents, name, n) {
      if (!window.fbq) return;
      var cids = String(idList || '').split(',').filter(Boolean);
      var data = { content_ids: cids, content_type: 'product', content_name: name || '', value: Math.round(cents || 0) / 100, currency: cur, num_items: n || cids.length };
      ids.forEach(function (id) { try { fbq('trackSingle', id, 'AddToCart', data); } catch (e) {} });
      try { if (typeof window.gtag === 'function') gtag('event', 'add_to_cart', { currency: cur, value: data.value, items: cids.map(function (c) { return { item_id: c, item_name: name || '' }; }) }); } catch (e2) {}
    };
    if (cfg.when === 'checkout') {
      /* 1 evento com o carrinho inteiro (sem brindes) no clique de finalizar compra; o Comprar agora da B avisa pelo pod:add com checkout */
      document.addEventListener('click', function (e) {
        var b = e.target.closest('.cart__checkout-button, [name="checkout"], a[href*="/checkout"], a[href="/cart"]'); if (!b) return;
        try {
          var x = new XMLHttpRequest(); x.open('GET', rootUrl() + 'cart.js', false); x.send();
          var c = JSON.parse(x.responseText); var its = (c.items || []).filter(function (i) { return !(i.properties && i.properties._brinde); });
          if (its.length) atc(its.map(function (i) { return i.variant_id; }).join(','), its.reduce(function (a, i) { return a + (i.final_line_price || 0); }, 0), 'Carrinho', its.reduce(function (a, i) { return a + i.quantity; }, 0));
        } catch (e3) {}
      }, true);
      document.addEventListener('pod:add', function (e) { var d = e.detail || {}; if (d.checkout) atc(d.id, d.value, d.name, d.n); });
    } else {
      document.addEventListener('pod:add', function (e) { var d = e.detail || {}; atc(d.id, d.value, d.name, d.n); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source !== 'product-form' || !ev.cartData || ev.cartData.status) return;
          var c = ev.cartData; atc(c.variant_id || ev.productVariantId, c.final_line_price || c.price, c.product_title, c.quantity || 1);
        });
      }
    }
  }

  function init() {
    watchDrawer();
    initPixel();
    document.querySelectorAll('[data-pod-black-oferta]').forEach(initBlackOferta);
    document.querySelectorAll('[data-pod-black]').forEach(initBlack);
    /* versão B: sem hero com escada, a oferta assume a escada da barra do montador (faltam R$ X, economia, +4/+8/+12) */
    if (!document.querySelector('[data-pod-black]')) document.querySelectorAll('[data-pod-black-oferta]').forEach(initBlack);
    document.querySelectorAll('[data-pod-header]').forEach(initHeader);
    document.querySelectorAll('[data-pod-card]').forEach(initCard);
    document.querySelectorAll('[data-pod-pdp]').forEach(initBuybox);
    document.querySelectorAll('[data-pod-ugc]').forEach(initUgc);
    document.querySelectorAll('[data-pod-rev]').forEach(initReviews);
    document.querySelectorAll('[data-pod-kit-root]').forEach(initKit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
